import { Box, Typography } from '@mui/material';
import type { InventoryResource } from '@repo/api-gw-sdk';

import { StorageGatewayPolicy } from '@/components/storage-gateway/storageGatewayPolicy';

export const GatewayConnectionTab = ({
  entity,
}: {
  entity: InventoryResource;
}) => {
  if (!entity.dlsgPolicy) {
    return null;
  }

  return (
    <Box className='px-[40px] mt-[40px]' overflow='auto'>
      <Typography className='mb-[24px]'>
        Resource is connected to Eon Gateway.
      </Typography>
      <Box className='mb-[12px]'>
        <StorageGatewayPolicy policy={entity.dlsgPolicy} />
      </Box>
    </Box>
  );
};
